// Code generated by go generate; DO NOT EDIT.

export const supportedDatasources = new Set<string>([
  'aquaqanalytics-kdbbackend-datasource',
  'cloudwatch',
  'dlopes7-appdynamics-datasource',
  'doitintl-bigquery-datasource',
  'elasticsearch',
  'frser-sqlite-datasource',
  'grafadruid-druid-datasource',
  'grafana-athena-datasource',
  'grafana-azure-data-explorer-datasource',
  'grafana-azure-monitor-datasource',
  'grafana-bigquery-datasource',
  'grafana-clickhouse-datasource',
  'grafana-databricks-datasource',
  'grafana-datadog-datasource',
  'grafana-db2-datasource',
  'grafana-dynatrace-datasource',
  'grafana-es-open-distro-datasource',
  'grafana-github-datasource',
  'grafana-honeycomb-datasource',
  'grafana-iot-sitewise-datasource',
  'grafana-jira-datasource',
  'grafana-mock-datasource',
  'grafana-mongodb-datasource',
  'grafana-newrelic-datasource',
  'grafana-odbc-datasource',
  'grafana-opcua-datasource',
  'grafana-opensearch-datasource',
  'grafana-oracle-datasource',
  'grafana-orbit-datasource',
  'grafana-redshift-datasource',
  'grafana-salesforce-datasource',
  'grafana-saphana-datasource',
  'grafana-sentry-datasource',
  'grafana-servicenow-datasource',
  'grafana-snowflake-datasource',
  'grafana-splunk-datasource',
  'grafana-splunk-monitoring-datasource',
  'grafana-timestream-datasource',
  'grafana-wavefront-datasource',
  'grafana-x-ray-datasource',
  'graphite',
  'hadesarchitect-cassandra-datasource',
  'influxdb',
  'innius-grpc-datasource',
  'kniepdennis-neo4j-datasource',
  'loki',
  'marcusolsson-csv-datasource',
  'marcusolsson-ynab-datasource',
  'mssql',
  'mysql',
  'opentsdb',
  'postgres',
  'prometheus',
  'redis-datasource',
  'sentinelone-dataset-datasource',
  'tdengine-datasource',
  'vertamedia-clickhouse-datasource',
  'vertica-grafana-datasource',
  'yesoreyeram-infinity-datasource',
]);
